module.exports = __webpack_public_path__ + "img/sorting_up.a74beb69.svg";